import { render, staticRenderFns } from "./SwapAchievementImagesButton.vue?vue&type=template&id=cf2e6d4a"
import script from "./SwapAchievementImagesButton.vue?vue&type=script&lang=js"
export * from "./SwapAchievementImagesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports